import { Series } from '@types';
import { LOCATIONS } from '@utils/locations';

const BANGKOK: Series = {
  id: 'bangkok',
  name: 'Bangkok',
  location: LOCATIONS.BANGKOK,
  sortType: 'date_asc',
  isZoneHighlight: true,
};

export default BANGKOK;
